module.exports = __webpack_public_path__ + "img/my_impower.6a6ddbc8.png";